// Assessment-stage editor state (the unsaved-format flag). The service holds the
// stage Apollo mutations. See CLAUDE.md "Client state lives in a per-context store".
import { createStore } from './create-store';

const [useHasUnsavedFormat, , setHasUnsavedFormat] = createStore(false);
export { useHasUnsavedFormat, setHasUnsavedFormat };
